import { createAction, props } from '@ngrx/store'
import { IHeaderFilterCriteria } from './header.reducers'

const SOURCE = '[Header Component]'

export const initStore = createAction(
    `${ SOURCE } initStore`,
    props<{key: string; alreadyRead: boolean}>()
)

export const filter = createAction(
    `${ SOURCE } filter`,
    props<{key: string}>()
)

export const reset = createAction(
    `${ SOURCE } reset`,
    props<{key: string}>()
)

export const setItemCollection = createAction(
    `${ SOURCE } setItemCollection`,
    props<{key: string; itemCollection: any[]}>()
)

export const setFilterCriteria = createAction(
    `${ SOURCE } setFilterCriteria`,
    props<{key: string; criteria: IHeaderFilterCriteria}>()
)

export const updateFilterCriteria = createAction(
    `${ SOURCE } updateFilterCriteria`,
    props<{key: string; filterCriteriaFragment: any}>()
)